export default "__VITE_ASSET__Cot3y7dT__"